import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Scrolls to top of page on every navigation change
 * Works with pathname, search params, and navigation key changes
 */
const ScrollToTop = () => {
  const { pathname, search, key } = useLocation();

  useEffect(() => {
    // Multiple methods for maximum browser compatibility
    const scrollToTop = () => {
      // Method 1: Standard scroll
      window.scrollTo(0, 0);
      
      // Method 2: Document element (for some browsers)
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      
      // Method 3: Body scroll (for older browsers)
      if (document.body) {
        document.body.scrollTop = 0;
      }
      
      // Method 4: Scroll into view (fallback)
      const mainContent = document.getElementById('root');
      if (mainContent) {
        mainContent.scrollIntoView({ block: 'start' });
      }
    };

    // Execute immediately
    scrollToTop();
    
    // Also execute after a small delay for lazy-loaded content
    const timeoutId = setTimeout(scrollToTop, 100);
    
    return () => clearTimeout(timeoutId);
  }, [pathname, search, key]);

  return null;
};

export default ScrollToTop;
